<template>
  <div class="exit flex_div">
    <boxTitleMoudle :left="'0px'" :title="'出入口监测'">
      <div class="record">
        <section style="width: 100%; height: 29%">
          <img class="title" src="./img/record.png" alt="" />
          <span class="f-right1">
            离场人数:
            <i class="num digital" style="color: #ff833c">{{
              personnelGetInOutLogData.outNumber
            }}</i>
          </span>
          <span class="f-right1">
            进场人数:
            <i class="num digital" style="color: #3d7fff">{{
              personnelGetInOutLogData.inNumber
            }}</i>
          </span>
        </section>

        <section style="margin-top: 20px; width: 100%; height: 70%">
          <div class="flex_bet" style="padding: 0 20px">
            <div
              style="
                width: 25%;
                display: flex;
                flex-direction: center;
                justify-content: center;
                align-items: center;
              "
            >
              <img src="./img/person.gif" alt />
            </div>
            <div
              style="width: 73%; height: 115px; padding-left: 10px"
              class="flex_bet"
            >
              <div style="width: 25%; height: 115px">
                <img
                  style="height: 100%"
                  :src="personnelGetInOutLogData.avatar"
                  alt
                />
              </div>
              <div style="width: 25%; height: 115px">
                <img
                  style="height: 100%"
                  :src="personnelGetInOutLogData.photoUrl"
                  alt
                />
              </div>
              <div style="width: 45%; color: #fff">
                <p class="flex_bet m-top4">
                  <span>{{ personnelGetInOutLogData.personnelName }}</span>
                  <span
                    class="status"
                    :style="{
                      color:
                        personnelGetInOutLogData.inOutType == '离场'
                          ? 'rgba(255,131,60,1)'
                          : 'rgba(78, 211, 249, 1)',
                      backgroundColor:
                        personnelGetInOutLogData.inOutType == '离场'
                          ? '  rgba(255,131,60,0.2)'
                          : ' rgba(78,211,249,0.2)',
                    }"
                    >{{ personnelGetInOutLogData.inOutType }}</span
                  >
                </p>
                <p class="m-top4">
                  <span>{{ personnelGetInOutLogData.jobName }}</span>
                </p>
                <p class="m-top4">
                  <span>{{ personnelGetInOutLogData.dateTime }}</span>
                </p>
                <p class="m-top4">
                  <span>{{ personnelGetInOutLogData.doorwayName }}</span>
                </p>
                <p class="m-top4">
                  <!-- <span style="color: #3D7FFF">相似度: 98%</span> -->
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="car">
        <section style="width: 100%; height: 29%">
          <img class="title" src="./img/car.png" alt="" />
          <span class="f-right1">
            离场车辆:
            <i class="num digital" style="color: #ff833c">{{
              personnelGetCarLogData.outNumber
            }}</i>
          </span>
          <span class="f-right1">
            进场车辆:
            <i class="num digital" style="color: #3d7fff">{{
              personnelGetCarLogData.inNumber
            }}</i>
          </span>
        </section>

        <section style="margin-top: 20px; width: 100%; height: 70%">
          <div class="flex_bet" style="padding: 0 20px">
            <div
              style="
                width: 25%;
                display: flex;
                flex-direction: center;
                justify-content: center;
                align-items: center;
              "
            >
              <img src="./img/car_icon.gif" alt />
            </div>
            <div
              style="width: 73%; height: 100%; padding-left: 10px"
              class="flex_bet"
            >
              <div style="width:50%;height:height:100%;">
                <img
                  style="height: 100%"
                  :src="personnelGetCarLogData.logImage"
                  alt
                />
              </div>

              <div style="width: 47%; color: #fff">
                <p class="flex_bet m-top4">
                  <span>{{ personnelGetCarLogData.carNumber }}</span>
                  <span
                    class="status"
                    :style="{
                      color:
                        personnelGetCarLogData.inOutType == '1'
                          ? 'rgba(78, 211, 249, 1)'
                          : 'rgba(255,131,60,1)',
                      backgroundColor:
                        personnelGetCarLogData.inOutType == '1'
                          ? ' rgba(78,211,249,0.2)'
                          : '  rgba(255,131,60,0.2)',
                    }"
                    >{{
                      personnelGetCarLogData.inOutType == "1" ? "进场" : "离场"
                    }}</span
                  >
                </p>

                <p class="m-top4">
                  <span>蓝色</span>
                </p>
                <p class="m-top4">
                  <span>{{ personnelGetCarLogData.dateTime }}</span>
                </p>
                <p class="m-top4">
                  <span>{{ personnelGetCarLogData.doorwayName }}</span>
                </p>
                <p class="m-top4">
                  <span style="color: #3d7fff">{{
                    personnelGetCarLogData.carStatus == "0"
                      ? "白名单车辆"
                      : "陌生车辆"
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </boxTitleMoudle>
  </div>
</template>
<script>
import "./css/home.scss";
import boxTitleMoudle from "@/components/BaseBoxTitleMoudle.vue";
export default {
  data() {
    return {
      enterNum: "20002",
      leaveNum: "20002",
      personnelGetInOutLogData: {},
      personnelGetCarLogData: {},
      carTimer: null,
      personTimer: null,
    };
  },
  components: {
    boxTitleMoudle,
  },
  created() {
    this.carTimer = setInterval(() => {
      this.personnelGetCarLog();
      this.personnelGetInOutLog();
    }, 3000);
  },
  mounted() {
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.carTimer);
    });
  },

  computed: {
    picServer() {
      return this.$store.state.picServer;
    },
  },
  methods: {
    personnelGetInOutLog() {
      this.$api.personnelGetInOutLog().then((res) => {
        if (res.code == "200") {
          this.personnelGetInOutLogData = res.data;
          this.personnelGetInOutLogData.avatar = this.personnelGetInOutLogData
            .avatar
            ? this.picServer + this.personnelGetInOutLogData.avatar
            : require("./img/noPic.png");
          this.personnelGetInOutLogData.photoUrl = this.personnelGetInOutLogData
            .photoUrl
            ? this.picServer + this.personnelGetInOutLogData.photoUrl
            : require("./img/noPic.png");
        }
      });
    },

    personnelGetCarLog() {
      this.$api.personnelGetCarLog().then((res) => {
        if (res.code == "200") {
          this.personnelGetCarLogData = res.data;
          this.personnelGetCarLogData.logImage = this.personnelGetCarLogData
            .logImage
            ? this.picServer + this.personnelGetCarLogData.logImage
            : require("./img/noPic1.png");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex_div {
  padding-top: 33px;
  width: 100%;

  height: 50%;
}
.digital {
  font-family: digital;
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
}
</style>